<div class="accordion" id="accordionExample" style="margin-top: -25px;">
    <div class="accordion-item">
        <h2 class="accordion-header" id="heading1">
            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                    data-bs-target="#collapse1" aria-expanded="false" aria-controls="collapse1">
                Bouwdepot
            </button>
        </h2>
        <div id="collapse1" class="accordion-collapse collapse" aria-labelledby="heading1"
             data-bs-parent="#accordionExample">
            <div class="accordion-body">
                Een bouwdepot moet je in principe opnemen in box 3 van de aangifte inkomstenbelasting. Het bouwdepot
                is een geldsom dat beschikbaar is gesteld voor de kosten van nieuwbouw of verbouwing. Toch mag je
                een bouwdepot tijdelijk in box 1 opnemen, voor zover het bouwdepot wordt aangemerkt als
                eigenwoningschuld. Het gaat dan om een bouwdepot in verband met de eigen woning.

                <div class="space10"></div>
                Is er sprake van een bouwdepot voor een tweede woning, een verhuurde woning of een verhuurd
                (bedrijfs)pand? Dan valt het bouwdepot in box 3, evenals de bijbehorende schuld.
            </div>
        </div>
    </div>

    <div class="accordion-item">
        <h2 class="accordion-header" id="heading2">
            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                    data-bs-target="#collapse2" aria-expanded="false" aria-controls="collapse2">
                Contant geld
            </button>
        </h2>
        <div id="collapse2" class="accordion-collapse collapse" aria-labelledby="heading2"
             data-bs-parent="#accordionExample">
            <div class="accordion-body">
                Je moet ook contant geld dat je in huis hebt op 1 januari {{ this.year }} aangeven. Ook het saldo op een
                chipkaart, de waarde van cadeaubonnen, vouchers en dergelijke horen bij contant geld. Heb je buitenlands
                contant geld? Reken dan om naar de euro. Gebruik daarbij de koers op 1 januari {{ this.year }}.

                <div class="space10"></div>
                Voor contant geld geldt een vrijstelling tot € {{ this.vrijstellingContantGeld | number:'1.0-0' }}. Heb
                je heel {{ this.year }} een fiscale partner? Dan wordt de vrijstelling verdubbeld. De vrijstelling voor
                contant geld tot € {{ this.vrijstellingContantGeld | number:'1.0-0' }} geldt ook voor minderjarige
                kinderen.
            </div>
        </div>
    </div>

    <div class="accordion-item">
        <h2 class="accordion-header" id="heading6">
            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                    data-bs-target="#collapse6" aria-expanded="false" aria-controls="collapse6">
                Vorderingen
            </button>
        </h2>
        <div id="collapse6" class="accordion-collapse collapse" aria-labelledby="heading6"
             data-bs-parent="#accordionExample">
            <div class="accordion-body">
                Bij je bezittingen horen bijvoorbeeld ook de vorderingen die je hebt op 1 januari {{ this.year }}. Het
                gaat hier om geld dat je tegoed hebt van anderen, bijvoorbeeld geld dat je hebt uitgeleend. Het kan ook
                gaan om een bezitting die je krijgt door een schenking op papier.
                <div class="space10"></div>

                Bij de vorderingen horen niet:
                <li class="list">spaartegoeden, obligaties en dergelijke</li>
                <li class="list">(toekomstige) belastingvorderingen en vorderingen premie volksverzekeringen. Let op!
                    Toeslagenvorderingen geef je wel aan.
                </li>
                <li class="list">een niet-opeisbare vordering uit een erfenis. Deze is meestal vrijgesteld.</li>
                <li class="list">lopende (rente)termijnen met een looptijd van 1 jaar of korter, bijvoorbeeld de
                    vordering van het
                    loon over december als je werkgever je loon te laat betaalt.
                </li>
                <div class="space10"></div>
            </div>
        </div>
    </div>

    <div class="accordion-item">
        <h2 class="accordion-header" id="heading3">
            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                    data-bs-target="#collapse3" aria-expanded="false" aria-controls="collapse3">
                Periodieke uitkeringen
            </button>
        </h2>
        <div id="collapse3" class="accordion-collapse collapse" aria-labelledby="heading3"
             data-bs-parent="#accordionExample">
            <div class="accordion-body">
                Sinds 2009 vallen alle rechten op periodieke uitkeringen waarvan de premies op grond van de polis
                aftrekbaar kunnen zijn volledig in box 1. Dit geldt bijvoorbeeld voor lijfrenteverzekeringen. Het maakt
                niet meer uit of je de premies niet (of niet helemaal) hebt afgetrokken, omdat daarvoor als aanvullende
                voorwaarde geldt dat je niet genoeg jaarruimte of reserveringsruimte moet hebben. Als de premies op
                grond van de polis aftrekbaar kunnen zijn, geef je de waarde van deze rechten dus <u>niet</u> aan bij je
                bezittingen.
                <div class="space10"></div>

                Rechten op periodieke uitkeringen waarvan de premies op grond van de polis niet aftrekbaar zijn in box
                1, moet je wel aangeven bij uw bezittingen. Je geeft van deze rechten de waarde aan in het economisch
                verkeer op 1 januari {{ this.year }}.
                <div class="space10"></div>

                Let op! De waarde van rechten op periodieke uitkeringen die je hebt afgesloten vóór 14 september 1999
                waarvoor in het verleden een eenmalige premie (koopsom) is voldaan, hoort <u>niet</u> bij je
                bezittingen, omdat die rechten in box 1 horen.
                <div class="space10"></div>

                Voor rechten op periodieke uitkeringen die vóór 14 september 1999 tegen periodieke premiebetaling zijn
                gesloten, geldt het volgende. Als de jaarpremie ervan uitkomt boven
                € {{ this.bedragPeriodiekeUitkeringen | number:'1.0-0' }}, dan moet je de waarde die
                wordt opgebouwd met het deel van de premie dat uitkomt boven die grens opgeven in box 3. Als de
                jaarpremie niet hoger is dan € {{ this.bedragPeriodiekeUitkeringen | number:'1.0-0' }} geef je de waarde
                ervan <u>niet</u> op in box 3.
                <div class="space10"></div>
                Kijk voor meer informatie over dit onderwerp hieronder bij 'Meer fiscale informatie'.

            </div>
        </div>
    </div>

    <div class="accordion-item">
        <h2 class="accordion-header" id="heading4">
            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                    data-bs-target="#collapse4" aria-expanded="false" aria-controls="collapse4">
                Netto pensioen
            </button>
        </h2>
        <div id="collapse4" class="accordion-collapse collapse" aria-labelledby="heading4"
             data-bs-parent="#accordionExample">
            <div class="accordion-body">
                Je kunt een vrijgesteld nettopensioen of nettolijfrente opbouwen over deel van je jaarloon dat hoger is
                dan € {{ this.bedragJaarloonNettoPensioen * 2 | number:'1.0-0' }}.
                <div class="space10"></div>
                Het bedrag dat je jaarlijks kunt inleggen (premie of inleg) voor een nettopensioen en nettolijfrente om
                voor de vrijstelling in box 3 in aanmerking te komen, is beperkt en moet voldoen aan een aantal
                voorwaarden. De hoogte van het maximaal te betalen bedrag is leeftijdsafhankelijk.
                <div class="space10"></div>
                Kijk voor meer informatie over dit onderwerp hieronder bij 'Meer fiscale informatie'.

            </div>
        </div>
    </div>

    <div class="accordion-item">
        <h2 class="accordion-header" id="heading5">
            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                    data-bs-target="#collapse5" aria-expanded="false" aria-controls="collapse5">
                Niet vrijgestelde kapitaalverzekering
            </button>
        </h2>
        <div id="collapse5" class="accordion-collapse collapse" aria-labelledby="heading5"
             data-bs-parent="#accordionExample">
            <div class="accordion-body">
                Verzekeringen die een kapitaal (een bedrag ineens) uitkeren bij leven of overlijden horen bij je
                vermogen. Je geeft de waarde aan van deze kapitaalverzekeringen die je hebt op 1 januari {{ this.year }}
                .
                <div class="space10"></div>
                Bij de volgende verzekeringen kun je recht hebben op een vrijstelling:
                <li class="list">een kapitaalverzekering die alleen uitkeert bij overlijden</li>
                <li class="list">een kapitaalverzekering die alleen uitkeert bij invaliditeit, ziekte of ongeval</li>
                <li class="list">een kapitaalverzekering die je hebt afgesloten op of voor 14 september 1999</li>
                <div class="space10"></div>

                <b>Kapitaalverzekering die alleen uitkeert bij overlijden</b><br/>
                Heb je een kapitaalverzekering die alleen uitkeert bij overlijden? Bijvoorbeeld een uitvaartverzekering
                die uitkeert in geld of in natura? Als het maximaal verzekerde kapitaal niet meer is dan
                € {{ this.bedragUitvaartverzekering | number:'1.0-0' }} per
                verzekerde, hoef je deze verzekering niet aan te geven. Het gaat om een verzekering die uitkeert bij
                overlijden van jezelf, je fiscale partner of een bloed- of aanverwant, zoals je kinderen, ouders, broers
                of zussen en hun echtgenoten.
                <div class="space10"></div>
                Is het verzekerd kapitaal van een polis meer dan € {{ this.bedragUitvaartverzekering | number:'1.0-0' }}
                ?
                Dan hoort de waarde van die polis wel bij je
                bezittingen. Was echter de waarde in het economisch verkeer van al je polissen samen niet meer dan €
                {{ this.bedragUitvaartverzekering | number:'1.0-0' }? Dan heb je recht op de vrijstelling en hoef je de
                verzekering niet aan te geven.
                <div class="space10"></div>
                <b>Kapitaalverzekering die alleen uitkeert bij invaliditeit, ziekte of ongeval</b><br/>
                Heb je een kapitaalverzekering die alleen uitkeert bij invaliditeit, ziekte of ongeval? Dan geldt dat de
                waarde van deze verzekering is vrijgesteld. De waarde van deze verzekering hoef je niet aan te geven in
                box 3.
                <div class="space10"></div>
                <b>Kapitaalverzekering afgesloten vóór 15 september 1999 (géén kapitaalverzekering
                    eigen woning)</b><br/>
                Heb je 1 of meer kapitaalverzekeringen afgesloten op of vóór 14 september 1999? En is na 13 september
                1999 het verzekerd kapitaal of de premie niet verhoogd en de looptijd van de verzekering niet verlengd?
                Dan tellen de verzekeringen niet mee bij je bezittingen als de gezamenlijke waarde van deze
                kapitaalverzekeringen op 1 januari {{ this.ibAangifte.aangifteJaar }}
                € {{ this.bedragKapitaalverzekering | number:'1.0-0' }} of lager
                is. Is de waarde hoger? Dan telt alleen de
                waarde boven € {{ this.bedragKapitaalverzekering | number:'1.0-0' }} mee bij je bezittingen in box 3.
                Heb je het hele jaar een fiscale partner? Dan is
                de vrijstelling voor je samen € {{ this.bedragKapitaalverzekering * 2 | number:'1.0-0' }}.
                <div class="space10"></div>
                Is het verzekerde kapitaal of de premie na 13 september 1999 wel verhoogd? Dan mag je de vrijstelling
                alleen gebruiken als die verhoging plaatsvond op basis van een clausule die op 13 september 1999 al
                bestond. De vrijstelling vervalt als de looptijd van de verzekering na 13 september 1999 is verlengd.
                <div class="space10"></div>
                Kijk voor meer informatie over dit onderwerp hieronder bij 'Meer fiscale informatie'.
            </div>
        </div>
    </div>

    <div class="accordion-item">
        <h2 class="accordion-header" id="heading7">
            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                    data-bs-target="#collapse7" aria-expanded="false" aria-controls="collapse7">
                Overige
            </button>
        </h2>
        <div id="collapse7" class="accordion-collapse collapse" aria-labelledby="heading7"
             data-bs-parent="#accordionExample">
            <div class="accordion-body">
                Overige bezittingen die je moet aangeven in box 3 zijn bijvoorbeeld:
                <li class="list">je aandeel in een onverdeelde boedel</li>
                <li class="list">vruchtgebruik of beperkt eigendom van een spaarrekening</li>
                <li class="list">vruchtgebruik of beperkt eigendom (zoals bloot eigendom) van een pand, landgoed in de
                    zin van de
                    Natuurschoonwet 1928, bos of natuurterrein
                </li>
                <li class="list">roerende zaken die je verhuurt of als belegging hebt</li>
                <li class="list">rechten op roerende zaken, bijvoorbeeld het recht om een auto of caravan van een ander
                    (niet je
                    werkgever) gratis het hele jaar te gebruiken
                </li>
                <li class="list">trustvermogen of een vergelijkbaar doelvermogen naar buitenlands recht (ook als je
                    hieruit geen
                    inkomsten had)
                </li>
                <li class="list">recht op het gebruik van een pand.<br/>
                    Het gaat om het recht op het gebruik van een pand waarvoor je minder dan 1 keer per jaar een
                    zakelijke vergoeding betaalt. Je betaalt bijvoorbeeld steeds de huur voor 5 jaar vooruit.
                </li>
                <li class="list">virtuele betaalmiddelen, zoals bitcoins</li>
                <div class="space10"></div>

                Bij de overige bezittingen horen bijvoorbeeld niet:
                <li class="list">door een erfenis gekregen vruchtgebruik van de woning die je hoofdverblijf is.<br/>
                    Dit valt onder je eigen woning in box 1.
                </li>
                <li class="list">roerende zaken voor eigen gebruik of voor gebruik binnen het gezin, bijvoorbeeld je
                    eigen auto of de
                    inboedel van je woning
                </li>
                <li class="list">kunstvoorwerpen: deze zijn over het algemeen vrijgesteld</li>
                <li class="list">door een erfenis gekregen rechten op roerende zaken die jezelf gebruikt</li>

                <div class="space10"></div>
                Er zijn speciale regels in geval van een aandeel in een onverdeelde boedel, vruchtgebruik of beperkt
                eigendom. Lees meer hieronder in 'Meer fiscale informatie'.
            </div>
        </div>
    </div>

</div>


